import { Box } from "@mui/material";
import SalesTickets from "./SalesTickets";
import { useSearchParams } from "react-router-dom";

const ConsumablesPosPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  let search = searchParams.get("search");
  let status = searchParams.get("status");

  return (
    <Box>
      <SalesTickets search={search} status={status ?? "ALL"} />
    </Box>
  );
};

export default ConsumablesPosPage;
